import { useEffect } from "react";
import "./style.css";
import bgEn from "../../assets/image/home/bg_en.jpg";
import bgTc from "../../assets/image/home/bg_tc.jpg";

import { useParams } from "react-router-dom";
import { toAppStore, redirectToAppStore } from "../../util/common";

const Home = () => {
  const { lang } = useParams();

  useEffect(() => {
    const pathname = window.location.pathname;

    if (pathname !== "/" && pathname !== "/en" && pathname !== "/zh") {
      redirectToAppStore();
    }
  }, []);

  const iosClick = () => {
    window.location.href =
      "https://apps.apple.com/hk/app/caf%C3%A9-de-coral/id1436965382";
  };

  const aosClick = () => {
    window.location.href =
      "https://play.google.com/store/apps/details?id=com.cdc.cdcmember";
  };

  return (
    <div className="container">
      <img
        src={lang === "en" ? bgEn : bgTc}
        alt="background_image"
        className="bg"
      />
      <div lang={lang} className="button-wrap">
        <button lang={lang} className="button ios-button" onClick={iosClick} />
        <button lang={lang} className="button aos-button" onClick={aosClick} />
      </div>
      <div lang={lang} className="download-wrap">
        <button
          lang={lang}
          className="button download-button"
          onClick={toAppStore}
        />
      </div>
    </div>
  );
};

export default Home;
